import beepURL from '../audio/beep.mp3';
import dingURL from '../audio/beep4.mp3';

const beepAudio = new Audio(beepURL);
const dingAudio = new Audio(dingURL);

export function beep() {
    if(window && window.innerWidth > 600) {
        beepAudio.play();
    }
}

export function ding() {
    if(window && window.innerWidth > 600) {
        dingAudio.play();
    }
}


// WEBPACK FOOTER //
// ./src/services/audio.js